import { JsonpClientBackend } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminCtrlVehGeocerca } from 'src/app/models/admin-ctrlvehiculo-geocerca';
import { ControlVehiculosService } from 'src/app/services/admin/control-vehiculos-service/control-vehiculos.service';
import { ControlGeocercaService } from 'src/app/services/flota/control-geocerca-service/control-geocerca.service';
import { ControlRutasService } from 'src/app/services/flota/control-rutas-service/control-rutas.service';
import { ConfirmDialog } from 'src/app/shared/confirmdialog/confirmdialog.component';
import { Gtp } from 'src/app/shared/gtp';
import { ControlVehiculosRutasAdd } from '../control-vehiculos-rutas-add/control-vehiculos-rutas-add.component';

@Component({
  selector: 'app-control-vehiculos-rutas',
  templateUrl: './control-vehiculos-rutas.component.html',
  styleUrls: ['./control-vehiculos-rutas.component.scss']
})
export class ControlVehiculosRutas implements OnInit, OnDestroy {    
  
  loading:boolean = false;
  public contClass: string = 'container-fluid maincont';
  public params = {
    latitud: null,
    longitud: null,
    descripcion: null,
    geocerca: null,
  };

  fechalang: any;

  //Listado de Geocercas
  public rutas = [];
  public rutasFiltered = [];
  //Geocercas en perfil
  public rutaEnPerfil = [];
  
  public intervaloNotif = null;
  
  public rangohoras = {
    lunes: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    martes: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    miercoles: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    jueves: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    viernes: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    sabado: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    domingo: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
  };

  public perfilData = {    
    rutaEnPerfil: null
  };

  public saveInterval;
  public defaultDate: Date;

  constructor(
    private gtp: Gtp,
    private dialog: MatDialog,
    private ctrlVehiculo: ControlVehiculosService,
  ) {
    
  }
  
  ngOnInit(): void {
    if (this.ctrlVehiculo.RutasConfig.length>0) {
      this.rutaEnPerfil = this.ctrlVehiculo.RutasConfig;
    }
  }

  ngOnDestroy():void{
    //if (this.saveInterval){ this.saveInterval.unsubscribe(); }
  }

  /**
   * Cierra la ventana del informe activa.
   */
  cerrarInforme() {
    this.gtp.cerrarVentanas(true);
  }

  /**
   * Aumenta o disminuye el tamaño del ancho en el informe.
   */
  containerSize() {
    this.contClass = this.gtp.containerSize(this.contClass);
  }

  addRuta() {
    // geo = new AdminCtrlVehGeocerca(geo);
    // let res = this.geoEnPerfil.filter(s => (s.geoid == geo.geoid));
    // if (res.length==0) { this.geoEnPerfil.push(geo); }
    const dialogRef = this.dialog.open(ControlVehiculosRutasAdd, {
      width: '1024px',
      data: {
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.ruta) {
          result.control.desde = (this.gtp.validDate(result.control.desde)) ? this.gtp.getHourMinuteSecond(result.control.desde) : null;
          result.control.hasta = (this.gtp.validDate(result.control.hasta)) ? this.gtp.getHourMinuteSecond(result.control.hasta) : null;
          console.log(result);
          this.rutaEnPerfil.push(result);
        }
      }
    }); 
  }
  
  removeRuta(id, pos){
    const dialogRef = this.dialog.open(ConfirmDialog, {
      width: this.gtp.confirmMinWidh,
      data: {
        value: id,
        titulo: 'BORRAR RUTA',
        descr: '¿Está seguro que querer eliminar el registro?',
        success_class: 'danger',
        success_text: 'Eliminar'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.rutaEnPerfil.splice(pos, 1);
      }
    });    
  }


  parseRangoHoras(){
    const rangohoras = {
      lunes: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.lunes.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.lunes.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.lunes.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.lunes.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.lunes.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.lunes.hasta.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.lunes.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.lunes.hasta.segundo) : null,
        }
      },
      martes: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.martes.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.martes.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.martes.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.martes.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.martes.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.martes.hasta.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.martes.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.martes.hasta.segundo) : null,
        }
      },
      miercoles: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.miercoles.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.miercoles.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.miercoles.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.miercoles.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.miercoles.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.miercoles.hasta.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.miercoles.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.miercoles.hasta.segundo) : null,
        }
      },
      jueves: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.jueves.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.jueves.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.jueves.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.jueves.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.jueves.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.jueves.hasta.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.jueves.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.jueves.hasta.segundo) : null,
        }
      },
      viernes: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.viernes.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.viernes.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.viernes.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.viernes.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.viernes.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.viernes.hasta.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.viernes.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.viernes.hasta.segundo) : null,
        }
      },
      sabado: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.sabado.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.sabado.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.sabado.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.sabado.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.sabado.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.sabado.hasta.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.sabado.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.sabado.hasta.segundo) : null,
        }
      },
      domingo: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.domingo.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.domingo.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.domingo.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.domingo.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.domingo.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.domingo.hasta.primero) : null,
          segundo:(this.gtp.validDate(this.rangohoras.domingo.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.domingo.hasta.segundo) : null,
        }
      }
    };
    return rangohoras;
  }

  parseRutas(){
    var geo = [];
    this.rutaEnPerfil.forEach(el => {
      el.maxparada = this.gtp.getHourMinuteSecond(el.maxparada);
      geo.push(el);
    });
    return geo;
  }

  saveParams(){
    this.perfilData = JSON.parse(JSON.stringify(this.rutaEnPerfil));      
    this.ctrlVehiculo.setRutasConfig(this.perfilData);    
    console.log('Actualizando...');
  }

}
